import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Router} from '@angular/router';
import { LoginModalService } from '../login-modal.service';
import { AuthService } from '../service/auth.service';
import { AppConstants } from '../AppConstants';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})
export class ProductListComponent implements OnInit {

  rowData: any;
  tenant: any;
  imageList: any;
  imageObject1: any = [];
  imageObject: Array<object> = [];
  serviceChips: any[] = [];

  rules: any[] = [];
  //googleMapLink: any;
  // mgObj = {};
  public id: any;


  constructor(
    private router: Router,
    private authService: AuthService,
    private loginModalService: LoginModalService,
    private aRoute: ActivatedRoute
  ) {}

  /* productDetails(id): void {
    console.log("Tenant Id: ", id);

    this.router.navigate(['/products-details', id]);
    console.log("I am here");
  } */
  productDetails(id): void {

    console.log("Tenant Id: ", id);

    if (!this.authService.isLoggedIn()) {

      this.authService.setStoredItem(
        'postLoginUrl',
        '/products-details/' + id
      );

      this.loginModalService.setLoginModalData(true);

      return;
    }

    this.router.navigate(
      ['/products-details', id]
    );

    console.log("I am here");
  }

  ngOnInit() {
    this.id = this.aRoute.snapshot.paramMap.get('id');

    this.getAmenitiesByTenant(this.id);
    this.getImagesForTenant(this.id);
    this.getTenantById(this.id);
    this.getRulesByTenant(this.id);
    this.loadServiceChips(this.id);
  }


  getTenantById(id) {
    this.authService.getSauByTenantId(id).subscribe(
      (response) => {
        console.log("Tenant: ", response);

        this.tenant = response;
        //this.googleMapLink = this.tenant.googleMapsLink;
        console.log("Map ", this.tenant.googleMapsLink);

      },
      (error) => {

      }
    );
  }

  getAmenitiesByTenant(id) {
    this.authService.getAllAmenitiesSauByTenantId(id).subscribe(
      (response) => {
        console.log("Amenities: ", response);

        this.rowData = response;
      },
      (error) => {

      }
    );
  }
  cancelSlots(): void {
      this.router.navigate(['/']);
  }

  getImagesForTenant(id) {
    this.authService.getAllProductsImagesSauByTenantId(id).subscribe(
      (imageList) => {
        this.imageList = imageList;
        console.log(this.imageList);
        this.imageObject1 = [];

        if (this.imageList?.images?.length > 0) {

          const defaultIndex = this.imageList.defaultImageIndex || 0;

          const sortedImages = [
            this.imageList.images[defaultIndex],
            ...this.imageList.images.filter((_, index) => index !== defaultIndex)
          ];

          sortedImages.forEach(img => {
            this.imageObject1.push({
              image: img,
              thumbImage: img
            });
          });
        }

        this.imageObject = [...this.imageObject1];

        this.imageObject = this.imageObject1;
        console.log("imageObj:", this.imageObject);

      },
      (error) => {

      }
    );
  }
  getAllPhoneNumbers(tenant: any): string {
      let phoneNumbers : string = '';

      if (tenant && tenant.contactPhoneNumber1) {
        phoneNumbers = tenant.contactPhoneNumber1 }
      if (tenant && tenant.contactPhoneNumber2) {
              phoneNumbers += " / " + tenant.contactPhoneNumber2 }
      /* if (tenant.contactPhoneNumber3) {
                    phoneNumbers += " / " + tenant.contactPhoneNumber3 }
  */

      return phoneNumbers;
  }

  getRulesByTenant(id) {

    this.authService.getTenantRulesByTenantId(id).subscribe(
      (response) => {

        console.log("Rules: ", response);

        this.rules = response as any[];

        if (this.rules && this.rules.length > 0) {

          this.rules.sort(
            (a, b) => a.ruleIndex - b.ruleIndex
          );

        }

      },
      (error) => {

        console.log(error);

      }
    );

  }


  loadServiceChips(id: number) {

    this.authService.getAllProductsByTenantId(id)
      .subscribe((products: any[]) => {

        const uniqueServices = new Set<string>();
        let hasCoaching = false;

        products.forEach(product => {

          if (product.status !== 'Active') {
            return;
          }

          if (product.serviceType) {
            uniqueServices.add(product.serviceType);
          }

          if (product.isCoaching === true) {
            hasCoaching = true;
          }

        });

        this.serviceChips = [];

        uniqueServices.forEach(serviceType => {

          this.serviceChips.push({
            name: AppConstants.getServiceName(serviceType),
            icon: `../../assets/img/${serviceType}`
          });

        });

        if (hasCoaching) {

          this.serviceChips.push({
            name: 'Coaching',
            icon: '../../assets/img/coach.svg'
          });

        }

        console.log('Service Chips', this.serviceChips);

      });
  }



}
